import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { TempStore } from "./types";
import moment from "moment";

const initialState: TempStore = {};

const tempSlice = createSlice({
    name: "tempStore",
    initialState: initialState,
    reducers: {
        saveInTemp: (state: TempStore, action: PayloadAction<any>) => {
            let key = Object.keys(action.payload);
            key.forEach((el: string) => {
                state[el] = action.payload[el];
            });
            state.lastUpdate = moment().format("YYYY-MM-DDTHH:mm");
        },
        removeFromTemp: (state: TempStore, action: PayloadAction<string>) => {
            delete state[action.payload];
            state.lastUpdate = moment().format("YYYY-MM-DDTHH:mm");
        },
        updateInTemp: (state: TempStore, action: PayloadAction<any>) => {
            state[action.payload.key] = action.payload.values;
            state.lastUpdate = moment().format("YYYY-MM-DDTHH:mm");
        },
        resetTemp: (state: TempStore) => {
            Object.keys(state).forEach((el: string) => {
                delete state[el];
            })
        }
    }
});

// Actions
export const tempActions = tempSlice.actions;

// Reducer
const tempReducer = tempSlice.reducer;
export default tempReducer;